import { Dispatch, SetStateAction } from "react";
import api from "./axios/api";
import { useFee } from "../context/FeeContext";
import i18n from "../i18n";

export async function getFeeUniversal(changeFee: Dispatch<SetStateAction<number>>){
    try {
        const response = await api.get('/fee/Taxa de venda geral')
        changeFee(response.data.value)
    } catch (error) {
        console.error("Not possible get fee")
    }
}

export function calculateWithFee(value: number, fee: number): string {
    const total = value + ((fee / 100) * value)
    return total.toLocaleString(i18n.language || "pt-BR", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    });
}

export function useCalculateWithFee() {
    const { fee } = useFee()
    return (value: number) => calculateWithFee(value, fee)
}
